import React from 'react'
import { PlaceHolderContainer, TeamContainer } from './styles'
import type { TeamRowProps } from './types'

const TeamRow: React.FC<TeamRowProps> = ({ children, isPlaceHolder = false }) =>
  isPlaceHolder ? <PlaceHolderContainer>{children}</PlaceHolderContainer> : <TeamContainer>{children}</TeamContainer>

export default TeamRow
